export const dayOptions = [
  { name: 'mon', nicename: 'Monday', dow: 1 },
  { name: 'tue', nicename: 'Tuesday', dow: 2 },
  { name: 'wed', nicename: 'Wednesday', dow: 3 },
  { name: 'thu', nicename: 'Thursday', dow: 4 },
  { name: 'fri', nicename: 'Friday', dow: 5 },
  { name: 'sat', nicename: 'Saturday', dow: 6 },
  { name: 'sun', nicename: 'Sunday', dow: 0 },
]

export const weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday']
export const weekends = ['Saturday', 'Sunday']
export const allDays = [...weekdays, ...weekends]

export const sortDays = function (a, b) {
  a = allDays.indexOf(a)
  b = allDays.indexOf(b)
  return a - b
}

export const mapDays = function (raceDays) {
  let days = raceDays
    ?.map((raceDay) =>
      dayOptions.some((dayOption) => dayOption.name === raceDay)
        ? dayOptions.find((dayOption) => dayOption.name === raceDay).nicename
        : null,
    )
    .filter((d) => d)
    .sort(sortDays)

  return days
}
